import { ActionUiZone } from './action-ui-zone';
import { MxAction } from './action';

/**
	 * @ngdoc type
	 * @name mx.shell.ActionsContext
	 * @module mx.shell
	 *
	 * @description
	 * An implementation of actions context for an application context.
	 * Constructor accepts types, extraActions, uiZone as params like:
	 * ```javascript
	 var context = new mx.shell.ActionsContext(types, extraActions, uiZone);
	 * ```
	 * @property {object[]} types - Gets or sets a collection of types available. Default: []
	 * @property {mx.shell.Action[]} extraActions - Gets or sets list of additional Actions available for current context. Default: []
	 * @property {mx.shell.ActionUiZone} uiZone - Gets or sets {@ref mx.shell.ActionUiZone mx.shell.ActionUiZone}
	 * @property {boolean} hideActions - Gets or sets a flag that states no actions should be shown.
	 * which defines where on UI it should be shown. For example: `mx.shell.ActionUiZone.Toolbar`.
	 * If it is `undefined` (not set) then this property will not make any influence and will be shown everywhere where it possible.
	 */
export class ActionsContext {
	constructor(
		public types: string[] = [],
		public extraActions: MxAction[] = [],
		public uiZone?: ActionUiZone,
		public hideActions = false
	) {}

	/**
	 * @ngdoc method
	 * @name mx.shell.ActionsContext#concat
	 *
	 * @description
	 * Add types to action context.
	 *
	 * @param {object[] | mx.shell.ActionsContext} context - a context to be added.
	 */
	concat(context: ActionsContext | string[]) {
		if (!context) {
			throw new Error('Cannot concat an empty context');
		}
		const contextIsArray = Array.isArray(context);
		const types = contextIsArray ? context : context.types;

		if (!types) {
			throw new Error('Types for concat were not found');
		}

		types.forEach((item) => {
			if (!this.types.includes(item)) {
				this.types.push(item);
			}
		});

		if (!contextIsArray) {
			if (context.extraActions) {
				context.extraActions.forEach((item) => {
					if (!this.extraActions.includes(item)) {
						this.extraActions.push(item);
					}
				});
			}

			if (!this.uiZone) {
				this.uiZone = context.uiZone;
			}
		}
	}
}
